"use strict";

exports.__esModule = true;
exports.colors = void 0;
exports.colors = {
  blue20: '#eff4f7',
  blue30: '#d7e4eb',
  blue40: '#86adc4',
  blueBase: '#35779d',
  blue60: '#285976',
  blue70: '#1b3c4f',
  blue80: '#07232b',
  green20: '#f2f9f6',
  green30: '#e0f0ea',
  green40: '#a2d1c1',
  greenBase: '#64b298',
  green60: '#4b8572',
  green70: '#32594c',
  green80: '#1a2f28',
  red20: '#fcf1f1',
  red30: '#f9dcdc',
  red40: '#ec9797',
  redBase: '#e05151',
  red60: '#a83d3d',
  red70: '#702929',
  red80: '#3c1515',
  orange20: '#fdf7ef',
  orange30: '#faebd9',
  orange40: '#efc38e',
  orangeBase: '#e59b42',
  orange50: '#ac7432',
  orange70: '#734e21',
  orange80: '#33220e',
  purple20: '#f8f1f5',
  purple30: '#eedee8',
  purple40: '#cb9cbb',
  purpleBase: '#a85a8e',
  purple60: '#7e446b',
  purple70: '#542d47',
  purple80: '#2d1825',
  gray10: '#f6f6f8',
  gray20: '#eaeaee',
  gray30: '#dedfe2',
  gray40: '#d6d6da',
  gray50: '#aeaeb4',
  gray60: '#8e8e93',
  gray70: '#636366',
  gray80: '#2c2c2e',
  black: '#000',
  white: '#fff'
};